import {initComplexLayout} from './initComplexLayout';
import {initFloorLayout} from './initFloorLayout';
import {initLayout} from './initLayout';

import Swiper from 'swiper';
import {Pagination} from 'swiper/modules';

export const initSlider = ( slider ) => {
	const bookmarks = slider.querySelector( 'ul.bookmarks' );
	const isLoop = Boolean( slider.closest( 'div.view' ) );

	const swiper = new Swiper( slider, {
		modules: [Pagination],
		slidesPerView: 'auto',
		pagination: {
			el: bookmarks,
			clickable: true,
			renderBullet: function ( index, className ) {
				const slideTitle = this.slides[index].getAttribute('data-name');
				const mapSlide = this.slides[index].classList.contains('complex-layout');

				return `<li class="custom ${className} ${mapSlide ? 'map' : ''}" data-slide="${index}" mapSlide ? id="map-apartment-card-button" : "">${slideTitle}</li>`;
			},
		},
	} );

	const paginationButtons = swiper.pagination.el;

	paginationButtons?.addEventListener( 'click', ({target}) => {
		const activeIndex = target.getAttribute('data-slide');

		if (target.classList.contains('map'))
		{
			swiper.disable();
		}
		else
		{
			swiper.enable();
			swiper.slideTo(activeIndex);
		}
	} )

	swiper.on( 'slideChange', () => {
		if (!isLoop && swiper.activeIndex === swiper.slides.length - 1)
		{
			const mapContainer = slider.querySelector( 'li:not( .clone ) div.map.yandex' );

			swiper.disable();

			if ( mapContainer.classList.contains( 'required' ) )
				{
				mapContainer.classList.remove( 'required' );
				
				window.init_yandex_map();
			}
		}
	} );
	
	initLayout( slider );
	initFloorLayout( slider );
	initComplexLayout( slider );
};
